import React from 'react';
import { css } from 'linaria';
import cn from 'clsx';

import AppLink from '../../AppLink';

import { BREAKPOINT_LG } from '../../../utils/screens';
import LazyContent from '../../LazyContent';

const MAX_WIDTH = css`
  @media (min-width: ${BREAKPOINT_LG}px) {
    & a:nth-child(1) {
      display: block;
    }
  }

  @media (min-width: ${BREAKPOINT_LG + 200}px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));

    & a:nth-child(2) {
      display: block;
    }
  }
`;

const NavPromos = (props: any) => {
  const { navLevel, onNavFinished, promos } = props;
  const activePromos = promos.reduce((accum: any[], ele: any) => {
    if (ele.imageSrc && ele.imageSrc.length > 0) {
      accum.push(ele);
    }
    return accum;
  }, []);
  const isSoloPromo = activePromos.length === 1;

  return (
    <div className={cn(isSoloPromo ? undefined : MAX_WIDTH, 'flex gap-5 grid-cols-1 ml-5 h-60')}>
      {activePromos.map((promo: any) => (
        <LazyContent className={cn('relative h-60', { 'w-40': !isSoloPromo })} key={promo.imageSrc}>
          <AppLink
            className={cn({ hidden: !isSoloPromo })}
            href={promo.linkUrl}
            onClick={(event) => onNavFinished(event, navLevel)}
            tracking={{
              id: promo.imageAlt,
              block_name: 'category_nav',
              block_row: 'category_nav',
            }}
          >
            <img
              alt={promo.imageAlt}
              className={cn('h-60', { 'w-40': !isSoloPromo })}
              src={promo.imageSrc}
            />
          </AppLink>
        </LazyContent>
      ))}
    </div>
  );
};

export default NavPromos;
